<template>
  <li class="profile-nav onhover-dropdown pe-0 py-0">
    <div class="media profile-media">
      <img class="b-r-10" :src="userImage" alt="" width="40px" />
      <div class="media-body">
        <span>{{ generalStore.upn }}</span>
        <p class="mb-0 font-roboto">
          {{ generalStore.role }} <i class="middle fa fa-angle-down"></i>
        </p>
      </div>
    </div>
    <ul class="profile-dropdown onhover-show-div">
      <li>
        <vue-feather type="user"></vue-feather><span>Mi cuenta</span>
      </li>
      <li>
        <vue-feather type="settings"></vue-feather><span>Configuración</span>
      </li>
      <li @click="logout">
        <vue-feather type="log-in"></vue-feather><span>Cerrar</span>
      </li>
    </ul>
  </li>
</template>

<script>
import { useGeneralStore } from "@/stores/generalStore";
import { computed } from 'vue';
import { useRouter } from 'vue-router';

export default {
  name: 'Profile',
  setup() {
    const generalStore = useGeneralStore();
    const router = useRouter();
    
    const userImage = computed(() => {
      try {
        return require(`@/assets/images/users/${generalStore.id}.png`);
      } catch (e) {
        // Imagen por defecto si no existe
        return require('@/assets/images/users/user-default.png');
      }
    });
    
    return { generalStore, userImage, router };    
  },
  methods: {
    logout() {
      try {        
        // Eliminar la cookie AuthToken
        document.cookie = 'AuthToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        // Limpiar el store (y su persistencia en localStorage)
        this.generalStore.$reset();
        this.router.replace('/');
      } catch (e) {
        // ignore
      }
    },
  },
};
</script>
